import { escapeHtml } from './escape-html';

export const prettifyImageLabel = (
  lastName: Nullable<string>,
  firstName: Nullable<string>
) => {
  if (lastName) {
    if (firstName) {
      return `${lastName.substring(0, 1).toUpperCase()}${firstName
        .substring(0, 1)
        .toUpperCase()}`;
    }

    if (lastName.length > 1) {
      return lastName.substring(0, 2).toUpperCase();
    }

    return lastName.substring(0, 1).toUpperCase();
  }

  return '';
};

export interface PostalAddress {
  street?: string;
  zip?: string;
  locality?: string;
  country?: string;
}

const addressLines = ({ street, zip, locality, country }: PostalAddress) =>
  [street, [zip, locality].filter(Boolean).join(' '), country].filter(
    (line): line is string => !!line
  );

export const prettyfyAddress = (address: PostalAddress) =>
  addressLines(address).map(escapeHtml).join('<br>');

export const prettyfyAddressURI = (address: PostalAddress) =>
  addressLines(address).join(' ');
